import {
    DisplayableMissionDto,
    InUseMissionWorkflowVersionDto
} from '@flyfreely-portal-ui/flyfreely';

/**
 * Determine if the workflow in the saved/initial mission exists, or
 * now has a different version, or is missing.
 *
 * @param mission the current saved, or initial mission
 * @param workflowList the available workflows
 */
export function findWorkflowSelectionValidity(
    mission: DisplayableMissionDto | null,
    workflowList: InUseMissionWorkflowVersionDto[]
): 'VALID' | 'MISSING' | 'DIFFERENT_VERSION' {
    if (mission == null || mission.missionWorkflowVersion == null) {
        return 'VALID';
    }
    const existingWorkflow = mission.missionWorkflowVersion;

    const workflow = workflowList.find(
        w => w.workflowId === existingWorkflow.workflowId
    );
    if (workflow == null) {
        return 'MISSING';
    }

    return workflow.id === existingWorkflow.id ? 'VALID' : 'DIFFERENT_VERSION';
}
